<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button parkourBackButton />
    </ion-buttons>

    <ion-title aria-level="1" role="heading">{{ 'profiel.qr-code-title' | translate }}</ion-title>

    <ion-buttons slot="end">
      <parkour-header-action
        (clicked)="close()"
        [label]="'buttons.sluiten' | translate"
        icon="cross"
      />
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <parkour-page-layout>
    @if (!isNativeApp()) {
      <zxing-scanner
        (camerasFound)="onCamerasFound($event)"
        (deviceChange)="onDeviceChange($event)"
        (permissionResponse)="onHasPermission($event)"
        (scanError)="scanError()"
        (scanSuccess)="scanSucces($event)"
        [device]="deviceCurrent"
        [enable]="scanActive"
        [formats]="allowedFormats"
        class="!flex items-center justify-center w-full h-full"
      />
    }

    <div class="py-8 container container-space">
      <!-- TODO: UX Copy team aan JSON toevoegen -->
      <div class="container-1-col">
        @if (hasPermission === undefined) {
          <p>Wachten voor camera rechten</p>
        }
        @if (!hasPermission) {
          <p>Je hebt geen toegang gegeven tot camera rechten.</p>
        }
        @if (hasDevices === undefined) {
          <p>Kan geen camera vinden.</p>
        }
        @if (!hasDevices) {
          <p>Kan geen camera vinden.</p>
        }
      </div>
    </div>
  </parkour-page-layout>
</ion-content>

<parkour-popup
  (hasBeenDismissed)="isNoPermissionsPopupOpen = false"
  [isOpen]="isNoPermissionsPopupOpen"
  icon="alert-triangle"
>
  <div content>
    <p class="typo-body variant-body-fat">PARKOUR wil je camera gebruiken</p>

    <p>Geef toestemming voor gebruik van de camera in je Instellingen.</p>
  </div>

  <div class="flex items-center gap-x-4" footer>
    <parkour-button (clicked)="isNoPermissionsPopupOpen = false" class="w-full" variant="tertiary">
      Terug
    </parkour-button>

    <!--    <parkour-button (clicked)="openSettings()" class="w-full"> Instellingen openen </parkour-button>-->
  </div>
</parkour-popup>
